import { render } from "./CardRenderSymbolComponent.vue?vue&type=template&id=2e3b4dba&ts=true"
import script from "./CardRenderSymbolComponent.vue?vue&type=script&lang=ts"
export * from "./CardRenderSymbolComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__